/**
 * Provider for source_type
 * Ported from [segmenter.getSourceType@58fbbd4d2773e1b3b806ebd5191914914a4fe0de](https://github.com/optimizely/optimizely/blob/355acdd0edd085bc3c19163de55f909d2a239f8c/src/www/js/client/segmenter.js#L213)
 * @module
 */
var BrowserSource = require('core/utils/browser');
var DocumentEnv = require('core/env/document');
var RedirectUtil = require('core/utils/redirect');
var url = require('core/utils/url');

var SEARCH_TESTS = [
  // non-SSL google search
  'google\\.\\w{2,3}(\\.\\w{2,3})?/(search|url)',
  'bing\\.\\w{2,3}(\\.\\w{2,3})?/(search|url)',
  'yahoo\\.\\w{2,3}(\\.\\w{2,3})?/search',
  'baidu\\.\\w{2,3}(\\.\\w{2,3})?/',
  // SSL search sets a referrer with no path (except for baidu)
  'https://(www)?\\.google\\..*?/?$',
  'https://search\\.yahoo\\..*?/?$',
  'https://(www)?\\.bing\\..*?/?$',
];

module.exports = {
  provides: 'source_type',
  shouldTrack: true,

  isSticky: false,

  getter: [
    function() {
      return function(getValue, setValue) {

        var getCurrentSourceType = function() {
          // TODO make these return values Enums
          if (BrowserSource.getQueryParamValue('utm_source') ||
              BrowserSource.getQueryParamValue('utm_campaign') ||
              BrowserSource.getQueryParamValue('gclid') ||
              BrowserSource.getQueryParamValue('otm_source')) {
            return 'campaign';
          }

          var referrer = RedirectUtil.getReferrer() || DocumentEnv.getReferrer();
          for (var i = 0; i < SEARCH_TESTS.length; i++) {
            var searchRegExp = SEARCH_TESTS[i];
            var match = referrer.match(searchRegExp);
            if (match) {
              return 'search';
            }
          }
          if (referrer && url.guessDomain(referrer) !== url.guessDomain(BrowserSource.getUrl())) {
            return 'referral';
          }
          return 'direct';
        };

        var shouldUpdate = function(previousSourceType, newSourceType) {
          return !previousSourceType || newSourceType !== 'direct';
        };

        var previousSourceType = getValue();
        var newSourceType = getCurrentSourceType();

        if (shouldUpdate(previousSourceType, newSourceType)) {
          setValue(newSourceType);
        }
      };
    },
  ],
};
